export const invalidPostCodes = ["00-000", "11-111"];
